import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Button } from "primereact/button";
import { InputOtp } from 'primereact/inputotp';
import { SubmitHandler } from "react-hook-form";
import SignInOTPResponse from "../../Models/Authentication/SignInOTPResponse";
import { dateUtilFull } from "../../Util/dateUtil";
import { useTranslation } from "react-i18next";

interface AuthenticationFormPropsComponent {
    onSubmit: SubmitHandler<any>;
    mfaSend: SubmitHandler<any>;
    signInOTPResponse: SignInOTPResponse;
    setSuccessMessage: Dispatch<SetStateAction<string | null>>;
    setErrorMessage: Dispatch<SetStateAction<string | null>>;
    data: any
}

const Authentication = ({ setSuccessMessage, signInOTPResponse, onSubmit, mfaSend, data }: AuthenticationFormPropsComponent) => {
    const { control, handleSubmit } = useForm<{ otp: string }>();
    let date = signInOTPResponse.expiryDate?.toString();
    const { t } = useTranslation();
    const [disabled, setDisabled] = useState(false);
    const [countdown, setCountdown] = useState(0);


    useEffect(() => {
        const firstInput = document.querySelector('.p-inputotp-input:first-child') as HTMLInputElement;
        if (firstInput) {
            firstInput.focus();
        }
    }, []);


    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                handleSubmit(onSubmit)();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [handleSubmit, onSubmit]);


    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => {
                setCountdown((prev) => prev - 1);
            }, 1000);
            return () => clearTimeout(timer);
        } else {
            setDisabled(false);
        }
    }, [countdown]);

    useEffect(() => {
        if (signInOTPResponse.type == "MFAPP") {
            setSuccessMessage(t("mfa.code.login"));
        } if (signInOTPResponse.type == "EMAIL") {
            setSuccessMessage(t("mfa.email.login"));
        }
    }, [setSuccessMessage, signInOTPResponse.type, t]);

    const startCountdown = () => {
        setCountdown(30);
        setDisabled(true);
    };

    return (
        <div className="auth">
            <form className="sign-in__form" onSubmit={handleSubmit(onSubmit)}>
                {date && signInOTPResponse.type == "EMAIL" && (
                    <p>{t("auth.valid.till")} {dateUtilFull(date)}</p>
                )}

                <Controller
                    name="otp"
                    control={control}
                    render={({ field }) => (
                        <InputOtp
                            length={6}
                            id={field.name}
                            value={field.value || ''}
                            onChange={(e) => field.onChange(e.value)}
                            required
                            className="otp"
                            autoComplete="off"
                        />
                    )}
                />

                {signInOTPResponse?.type === 'EMAIL' && (
                    <a
                        onClick={!disabled ? () => { startCountdown(); mfaSend(data) } : undefined}
                        style={{ pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? 0.5 : 1 }}
                    >
                        {disabled ? `${t("mfa.send.again")} (${countdown})` : t("mfa.send.again")}
                    </a>
                )}

                <Button className="sign-in__submit" type="submit" label={t("login.submit")} />
            </form>
        </div>
    );
}

export default Authentication;
